export const passwordConstants = {
    GET_PASSWORD_RULES: 'GET_PASSWORD_RULES',
    GET_PASSWORD_CONFIG_API: 'GET_PASSWORD_CONFIG_API',
    FETCH_PROCESSED_PASSWORD_CONFIG: 'FETCH_PROCESSED_PASSWORD_CONFIG',
};
